var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLinkProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67235)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002 0.00195312C16.3825 0.00216265 17.502 1.12137 17.502 2.50195V17.502C17.5017 18.8823 16.3823 20.0017 15.002 20.002H5.00195C3.6214 20.002 2.50221 18.8825 2.50195 17.502V2.50195C2.50195 1.12124 3.62124 0.00195312 5.00195 0.00195312H15.002ZM10.002 15.002C6.7231 15.002 4.82003 16.0336 3.75195 17.1953V17.502C3.75221 18.1921 4.31175 18.752 5.00195 18.752H15.002C15.692 18.7517 16.2517 18.192 16.252 17.502V17.1953C15.184 16.0335 13.2809 15.002 10.002 15.002ZM10.002 6.25195C7.93089 6.25195 6.25195 7.93089 6.25195 10.002C6.25221 12.0728 7.93104 13.752 10.002 13.752C12.0727 13.7517 13.7517 12.0727 13.752 10.002C13.752 7.93101 12.0728 6.25216 10.002 6.25195ZM8.12695 2.50195C7.78177 2.50195 7.50195 2.78178 7.50195 3.12695C7.50221 3.47192 7.78193 3.75195 8.12695 3.75195H11.877C12.2218 3.75174 12.5017 3.47179 12.502 3.12695C12.502 2.7819 12.222 2.50216 11.877 2.50195H8.12695Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkProfile);
export default __webpack_public_path__ + "static/media/nav-link-profile.43f52dad6ed167a62d3c41d0a72318fe.svg";
export { ForwardRef as ReactComponent };